import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import './EngagementModal.css';
import { EngagementTabId, ReportFormat, ReportType, XLS } from '../../../../../Utils/Constants';
import SessionPolls from './SessionPolls';
import SessionSurvey from './SessionSurvey';
import SessionQAndAs from './SessionQAndAs';
import { Button } from 'reactstrap';
import Menu from '../../../../../Components/Menu/Menu';
import { getReportTypeMenuItems } from '../../../../../Components/Menu/MenuItemsHelper';
import DownloadIcon from '../../../../../Components/Buttons/DownloadIcon';
import { connect } from 'react-redux';
import { reportActions } from '../../../../../Reducks/Reports';

export class EngagementModal extends Component {
  static propTypes = {
    webinarKey: PropTypes.string,
    sessionKey: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    engagementTabs: PropTypes.any,
    webinarNameHeading: PropTypes.any,
    activeTabId: PropTypes.string,
    isBig: PropTypes.bool,
    reduced_user: PropTypes.object,
    submitReportGenerationJob: PropTypes.func
  };
  static contextTypes = {
    t: PropTypes.func
  };

  render() {
    const {
      isOpen,
      toggle,
      engagementTabs,
      statsRow,
      webinarNameHeading,
      activeTabId,
      webinarKey,
      sessionKey,
      isBig,
      reduced_user
    } = this.props;
    const { t } = this.context;
    return (
      <Modal
        isOpen={isOpen}
        shouldCloseOnOverlayClick={true}
        onRequestClose={toggle}
        className="engagementModalComponent"
        ariaHideApp={false}
        overlayClassName="engagementModalOverLay">
        <div className="engagementModalHeader">
          <div className="webinarNameRow">
            {webinarNameHeading}
            <i className="togo-icon togo-icon-closes close closeButton" onClick={toggle} />
          </div>
          <div className="tabAndDownloadRow">
            {engagementTabs}
            {!reduced_user.entitlements.isRestrictReportDownloadEnabled && (
              <div className="downloadEngagementButton">
                <Menu
                  isBig={isBig}
                  menuKey="engagementModalDownloadButton"
                  detailsMenu={this.buildEngagementReportMenuOptions()}
                  buttonComponent={
                    isBig ? <Button color="primary">{t('buttons.downloadCamelCase')}</Button> : <DownloadIcon />
                  }
                />
              </div>
            )}
          </div>
          <div>{statsRow}</div>
        </div>
        {this.displayEngagementContent(webinarKey, sessionKey, activeTabId)}
      </Modal>
    );
  }

  buildEngagementReportMenuOptions() {
    return getReportTypeMenuItems().map(item => {
      return {
        ...item,
        onClick: () => this.submitEngagementReportJob(item.id),
        text: item.title,
        iconClassName: item.iconClass,
        id: item.id
      };
    });
  }

  submitEngagementReportJob = format => {
    const reportFormat = format && format === XLS ? ReportFormat.XLSX : ReportFormat.CSV;
    const { submitReportGenerationJob, reduced_user, sessionKey } = this.props;
    submitReportGenerationJob(
      ReportType.SESSIONS_QANDA_FOLLOW_UP_REPORT,
      reportFormat,
      [sessionKey],
      reduced_user.user
    );
  };

  displayEngagementContent = (webinarKey, sessionKey, activeTabId = {}) => {
    const { isBig } = this.props;
    switch (activeTabId) {
      case EngagementTabId.POLL_TAB:
        return <SessionPolls isBig={isBig} />;

      case EngagementTabId.SURVEY_TAB:
        return <SessionSurvey isBig={isBig} />;

      case EngagementTabId.QANDA_TAB:
        return <SessionQAndAs isBig={isBig} sessionKey={sessionKey} />;
      default:
        console.warn('unknown engagementType');
        return null;
    }
  };
}

export default connect(
  state => ({
    reduced_user: state.reduced_user
  }),
  {
    submitReportGenerationJob: reportActions.submitReportGenerationJob
  }
)(EngagementModal);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Engagement/EngagementModal/EngagementModal.js